export const selectEventRecommendationsState = state => state.eventRecommendations || {};

export const selectAuthenticatedLandingRecommendations = state =>
  selectEventRecommendationsState(state).data || null;

export const selectAuthenticatedLandingRecommendationsLoading = state =>
  !!selectEventRecommendationsState(state).fetchInProgress;

export const selectAuthenticatedLandingRecommendationsError = state =>
  selectEventRecommendationsState(state).fetchError || null;

export const selectAuthenticatedLandingHasPreferences = state => {
  const recommendationsState = selectEventRecommendationsState(state);
  return recommendationsState.hasPreferences !== false;
};

export const selectAuthenticatedLandingRecommendationsUserId = state =>
  selectEventRecommendationsState(state).fetchedForUserId || null;

export const selectAuthenticatedLandingRecommendationsLastFetched = state =>
  selectEventRecommendationsState(state).lastFetched || 0;
